var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 16,
    viewBox: "0 0 96 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4261 11.1671C34.1739 13.9048 33.453 15.0394 31.588 14.2949C18.0679 8.89743 5.48759 7.69569 4.04305 7.30862C2.5985 6.92156 -3.95071 7.32058 3.7209 4.65876C12.347 1.66577 29.2444 6.18363 32.4261 11.1671Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1072 11.2561C61.4741 14.0638 62.0803 15.1284 63.9453 14.3839C77.4654 8.98646 90.0457 7.78471 91.4902 7.39765C92.9348 7.01058 99.4819 7.4155 91.8124 4.74779C82.7176 1.58434 65.9382 6.38907 63.1072 11.2561Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsF);
export default __webpack_public_path__ + "static/media/Brows F.de47d41f3042a7cf9540310542cd48b8.svg";
export { ForwardRef as ReactComponent };